import React, { useState } from "react";
import { useForm } from "react-hook-form";

// import JS files
import MuiSelect from "../shares/mui/MuiSelect";
import MuiDatePicker from "../shares/mui/MuiDatePicker";
import MuiButton from "../shares/mui/MuiButton";

// import others files

const newsMediaTypeList = [
  {
    value: "video",
    name: "ویدیو",
  },
  {
    value: "image",
    name: "گزارش تصویری",
  },
  {
    value: "audio",
    name: "رادیو",
  },
];

const newsTypeList = [
  {
    value: 'all',
    name: "همه اخبار",
  },
  {
    value: 'company',
    name: "اخبار شرکت‌ها",
  },
  {
    value: 'most_view',
    name: "پربیننده‌ترین",
  },
];

const Filter = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {},
  });
  return (
    <>
      <div className="hidden md:grid my-8 border-b border-mygrays-200 pb-4 grid-cols-12 gap-8 items-center">
        <div className="grid grid-cols-2  col-span-4">
          <div className="w-full">
            <MuiSelect
              size="small"
              onChange={(e) => props.setNewsType(e.target.value)}
              inputLabel="نوع خبر"
              label="news_type_label"
              control={control}
              name="news_type_name"
              value={props.newsType}
              defaultValue={props.newsType}
              register={{
                required: {
                  value: true,
                  message: "نقش کاربردی را انتخاب کنید",
                },
              }}
              labelId="sent_typel-label"
              id="sent_type-select"
              menuItems={
                props.type == "media" ? newsMediaTypeList : newsTypeList
              }
              fromApi={false}
              keyOnLoop="name"
            />
          </div>
          <div className="w-full mr-4">
            <MuiDatePicker
              onChange={(date) => props.setNewsDate(date)}
              value={props.newsDate}
              name="date_name"
              label="تاریخ"
            />
          </div>
        </div>
        <div className="md:col-span-6"></div>
        <div className=" col-span-2">
          <MuiButton
            variant="contained"
            color="primary"
            text="اعمال فیلتر"
            type="submit"
            isFullWidth
            // withoutOnClick
            onClick={props.filter_api}
          />
        </div>
      </div>
    </>
  );
};

export default Filter;
